export const ORDER_MAX_CASH_THRESHOLD = process.env.ORDER_MAX_CASH_THRESHOLD || 100.0;
export const ORDER_MAX_CHANGE_THRESHOLD = process.env.ORDER_MAX_CHANGE_THRESHOLD || 100.0;
export const APP_ENV = (process.env.NODE_ENV === 'production') ? 'production' : 'development';
